// @flow

import Oidc, { UserManager } from 'oidc-client';
import getIdentityServerConfig from '../constants/getIdentityServerConfig';
import getAppConfig from '../constants/getAppConfig';
import logger from './logger';

let userManager;

/*
The oidc-client-js library supports logging. You can set a logger by assigning
Oidc.Log.logger to anything that supports a info, warn, and error methods that
accept a params array. By default, no logger is configured.
*/

Oidc.Log.logger = logger;
const oidcConfig = getAppConfig().oidc;
Oidc.Log.level = (oidcConfig && /* istanbul ignore next */ oidcConfig.logLevel) || 1;

/**
 * Gets a user manager singleton for auth.
 *
 * @return {Object} A UserManager object from the oidc-client library.
 */
const getUserManager = () => {
  if (userManager) return userManager;
  userManager = new UserManager(getIdentityServerConfig().sso);
  return userManager;
};

export default getUserManager;
